export type Testimonial = {
  name: string;
  role: string;
  initial: string;
  content: string;
};

export const testimonials: Testimonial[] = [
  {
    name: "林一舟",
    role: "内容编辑",
    initial: "林",
    content:
      "做选题最怕信息是碎的。这里每个事件都有一条完整时间线，先看脉络再看细节，效率高很多。",
  },
  {
    name: "周未然",
    role: "高校学生",
    initial: "周",
    content:
      "以前刷到热点只能看到片段，现在会先来这里搜一下，看完全过程再决定要不要参与讨论。",
  },
  {
    name: "陈见山",
    role: "品牌运营",
    initial: "陈",
    content:
      "写公告前我会翻一下同类型事件的档案，看看别人怎么解释规则。这种公开复盘很有参考价值。",
  },
  {
    name: "苏晚晴",
    role: "自由撰稿人",
    initial: "苏",
    content:
      "最欣赏的是克制。没有夸张标题，不披露隐私，把该说的说清楚，这在围观类内容里很难得。",
  },
];

export type Principle = {
  title: string;
  desc: string;
  icon: string;
};

export const principles: Principle[] = [
  {
    title: "只整理公开信息",
    desc: "所有档案均来自公开渠道，标注时间与来源类型，不做推测式补全。",
    icon: "ri-file-search-line",
  },
  {
    title: "不触碰个人边界",
    desc: "不呈现个人身份、联系方式与账号凭证，可识别细节一律模糊处理。",
    icon: "ri-shield-check-line",
  },
  {
    title: "脉络先于结论",
    desc: "先把时间线讲清楚，再谈讨论焦点，避免用情绪代替事实。",
    icon: "ri-route-line",
  },
  {
    title: "错了就改",
    desc: "欢迎纠错与补充，核实后及时更新，并在档案中标注修改时间。",
    icon: "ri-refresh-line",
  },
];